import {Instance, types} from "mobx-state-tree"
import { MobxLocalizableString as LocalizableString } from "./LocalizableString";

export const Country = types.model("Country").props({
  id: types.identifier,
  name: types.string,
  names: types.maybeNull(LocalizableString),
  is_active: types.boolean,
  code: types.string,
  geonames_id: types.maybeNull(types.integer),
});

export type ICountry = Instance<typeof Country>
